module.exports = __webpack_public_path__ + "static/media/splash.69046ac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/splash.jpg
// module id = 1129
// module chunks = 0